import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import axios from 'axios';
import get from 'lodash/fp/get';
import { createQueryString } from '../../../../util/urlUtil';
import { GENERIC_ERROR_MESSAGE } from '../formActionUtils';
import { getQueryUtmParams } from '../../../../../client/analytics/utmUtil';
import { getPersistedSessionArrivalAvenue } from './registrationUtils';
import { sendRegisterSubmitEvent, sendRegisterSuccessEvent } from '../../../../../client/analytics/dataLayerService';
import { getPlatformDetails } from './platformUtils';
var config = window.__config;
var getAmplitudeDeviceId = get(['options', 'deviceId']);
var getTargetingConsentSetting = function getTargetingConsentSetting() {
  var consent = window.OnetrustActiveGroups || '';
  return consent.indexOf(',C0004,') > -1;
};
export var submitForm = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(values) {
    var successRedirect, onboarding, segments, utm, registrationAvenue, _getPlatformDetails, platform, appMode, formData, _yield$axios$post, _yield$axios$post$dat, token, userId, eventId, params;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            successRedirect = values.successRedirect, onboarding = values.onboarding, segments = values.segments;
            utm = getQueryUtmParams(window.location);
            registrationAvenue = getPersistedSessionArrivalAvenue();
            _getPlatformDetails = getPlatformDetails(), platform = _getPlatformDetails.platform, appMode = _getPlatformDetails.appMode;
            formData = _objectSpread(_objectSpread({
              utm: utm
            }, values), {}, {
              amplitudeDeviceId: getAmplitudeDeviceId(window.amplitude && window.amplitude.getInstance()),
              registrationAvenue: registrationAvenue,
              onboarding: onboarding,
              segments: segments,
              platform: platform,
              appMode: appMode,
              consent: {
                targeting: getTargetingConsentSetting()
              }
            });
            sendRegisterSubmitEvent();
            _context.next = 8;
            return axios.post("".concat(config.appUrl, "/api/auth/register"), formData, {
              withCredentials: true
            });
          case 8:
            _yield$axios$post = _context.sent;
            _yield$axios$post$dat = _yield$axios$post.data;
            token = _yield$axios$post$dat.token;
            userId = _yield$axios$post$dat.userId;
            eventId = _yield$axios$post$dat.eventId;
            if (token) {
              _context.next = 15;
              break;
            }
            throw new Error(GENERIC_ERROR_MESSAGE);
          case 15:
            params = {
              token: token
            };
            if (successRedirect) {
              params.success_redirect = encodeURIComponent(successRedirect);
            }
            sendRegisterSuccessEvent({
              userId: userId,
              eventId: eventId
            });
            window.location = "".concat(config.appUrl, "/register-success/").concat(createQueryString(params));
          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function submitForm(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchInvitationEmail = function fetchInvitationEmail(inviteCode) {
  return axios.get("".concat(config.appUrl, "/api/invite/").concat(inviteCode)).then(function (response) {
    return response.data.email;
  })["catch"](function (err) {
    return null;
  });
};